import React from 'react';

import { Loader } from '.';
import { useAppDispatch, useAppSelector } from "redux/hooks";
import {IframePage, IPostMessageAction, IPostMessageOptions} from 'types/iframe';
import { mustCatchPostMessage } from 'utils/iframeHelper';
import { getAndSetSellerById, setUserSellers } from 'redux/sellers/actions';
import {withParamsFrame} from "../HOCs";

const SellerNew: React.FC<IframePage> = ({ params }) => {
    const [loaded, setLoaded] = React.useState(false);

    const { sellerId, currentUserId, allSellers } = useAppSelector(({ users, sellers }) => ({
        sellerId: sellers.currentSeller.info.data?.id,
        currentUserId: users.currentUser.data.id,
        allSellers: sellers.allSellers
    }))

    const dispatch = useAppDispatch();

    React.useEffect(() => {
        const entityTemplate: IPostMessageOptions = {
            entity: "seller",
            action: "create"
        }
        const messageHandler = function (e: MessageEvent) {

            if(e.origin !== "https://lk.market") {
                return;
            }

            if(!e.data.hasOwnProperty("entity")) {
                return;
            }

            if(mustCatchPostMessage(entityTemplate, e.data)) {
                const data: IPostMessageAction = e.data;
                dispatch(getAndSetSellerById(data.id) as any);

                if(data?.name) {
                    const sellerData = {
                        id: data.id,
                        sellerName: data.name,
                        userId: currentUserId
                    }
                    dispatch(setUserSellers(
                        [
                            ...allSellers,
                            sellerData
                        ]
                    ))
                }
   
            }
            
        }

        window.addEventListener("message", messageHandler);
        return () => window.removeEventListener("message", messageHandler);
    }, [])

    return (
        <>
            <div className="xs:mx-3">
                <iframe className={`${!loaded ? 'min-h-[auto]' : 'page-iframe'}`} src={`https://lk.market/${sellerId}/seller/new${params}`}
                    title="Seller new"
                    width="100%"
                    height={`${loaded ? "calc(100vh-64px)" : "0px"}`}

                    onLoad={() => setLoaded(true)}
                ></iframe>
            </div>
            {
                !loaded && <Loader />
            }
        </>
    );
};

export default withParamsFrame(SellerNew);
